'use client';

import { useTranslations } from 'next-intl';
import { AiIcon } from '@components/ui/ai-icon';
import { Pressable } from '@components/mobile/controls/pressable';
import AppAddCreateButton from '@components/AppAddCreateButton';
import { useAgentsMembershipEnabled } from '@hooks/use-agents-membership';
import { useStartAgentChat } from '@hooks/use-start-agent-chat';
import { usePageChrome } from '@components/layout/page-chrome-context';

const CHROME_CIRCLE =
  'bg-card inline-flex size-11 shrink-0 items-center justify-center rounded-full text-foreground';

export function HeaderActions({
  organization_id,
  surface = 'mobile'
}: {
  organization_id: string;
  surface?: 'mobile' | 'desktop';
}) {
  const t = useTranslations();
  const { chrome } = usePageChrome();
  const agentsEnabled = useAgentsMembershipEnabled();
  const { start, loading } = useStartAgentChat(organization_id);

  return (
    <div className="flex items-center gap-1.5">
      {agentsEnabled ? (
        <Pressable
          feedback="scale"
          aria-label={t('common.ai-chat')}
          onClick={() => void start()}
          disabled={loading}
          className={CHROME_CIRCLE}
        >
          <AiIcon className="size-5" />
        </Pressable>
      ) : null}
      {surface === 'desktop' && !chrome?.hideDesktopCreateAction ? (
        <AppAddCreateButton
          organization_id={organization_id}
          variant="chrome"
        />
      ) : null}
    </div>
  );
}
